import { render } from "./Copa.vue?vue&type=template&id=2f8464eb&scoped=true"
import script from "./Copa.vue?vue&type=script&lang=js"
export * from "./Copa.vue?vue&type=script&lang=js"

import "./Copa.vue?vue&type=style&index=0&id=2f8464eb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8464eb"]])

export default __exports__